import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { api } from '../../../services';

import SMToolbar from './SMToolbar';
import SMTable from './SMTable';
import SMFormModal from './SMFormModal';
import SMAssetBindingModal from './SMAssetBindingModal';

import './ServiceManagers.css';

@inject('translationsStore')
@observer
class ServiceManagers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      serviceManagers: [],
      submitError: undefined,
      createLoading: false,
      createModalVisible: false,
      editLoading: false,
      editModalVisible: false,
      bindingLoading: false,
      bindingModalVisible: false,
      serviceManagerId: undefined,
      combinedAssets: [],
      availableAssets: [],
      assignedAssets: [],
      dataSource: [],
      targetKeys: [],
      serviceManagerFormData: {}
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true });
    return api('getServiceManagers').then(serviceManagers => {
      serviceManagers = serviceManagers.map(sm => ({ ...sm, key: sm.uin }));
      this.setState({ serviceManagers, loading: false });
    });
  }

  promptCreateServiceManager = () => {
    this.setState({
      createModalVisible: true
    });
  };

  handleCreateServiceManager = data => {
    const { translationsStore } = this.props;
    this.setState({ createLoading: true, submitError: undefined });
    let submitError = undefined;
    let apiData = Object.assign({}, data);
    this.removeEmpty(apiData);
    api('createServiceManager', apiData)
      .then(() => {
        this.loadData();
        this.hideCreateModal();
      })
      .catch(() => {
        submitError = translationsStore.translate('serviceManagers.create.error');
      })
      .then(() => {
        this.setState({ createLoading: false, submitError });
      });
  };

  cancelCreateServiceManager = () => {
    this.hideCreateModal();
  };

  hideCreateModal = () => {
    this.setState({
      createModalVisible: false,
      submitError: undefined
    });
  };

  promptEditServiceManager = serviceManagerId => {
    const { serviceManagers } = this.state;
    const serviceManagerFormData = serviceManagers.find(sm => sm.id === serviceManagerId);
    this.setState({
      editModalVisible: true,
      serviceManagerFormData,
      serviceManagerId
    });
  };

  removeEmpty = obj => {
    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') {
        this.removeEmpty(obj[key]);
      } else if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        delete obj[key];
      }
    });
  };

  handleEditServiceManager = data => {
    const { translationsStore } = this.props;
    const { serviceManagerId } = this.state;
    this.setState({ editLoading: true, submitError: undefined });
    let submitError = undefined;
    let apiData = Object.assign({}, data);
    this.removeEmpty(apiData);
    api('updateServiceManager', serviceManagerId, apiData)
      .then(() => {
        this.loadData();
        this.hideEditModal();
      })
      .catch(() => {
        submitError = translationsStore.translate('serviceManagers.edit.error');
      })
      .then(() => {
        this.setState({ editLoading: false, submitError });
      });
  };

  cancelEditServiceManager = () => {
    this.hideEditModal();
  };

  hideEditModal = () => {
    this.setState({
      editModalVisible: false,
      submitError: undefined
    });
  };

  promptAssetBinding = serviceManagerId => {
    let bindingModalVisible = false;
    let availableAssets = [];
    let assignedAssets = [];
    Promise.all([api('getAvailableAssetsWithActiveLead'), api('getServiceManagerAssets', serviceManagerId)])
      .then(([responseAvailableAssets, responseServiceManagerAssets]) => {
        availableAssets = (responseAvailableAssets || []).map(item => ({ id: item.id, imei: item.imei, plate: item.plate }));
        assignedAssets = (responseServiceManagerAssets || []).map(item => ({ id: item.id, imei: item.imei, plate: item.plate }));

        bindingModalVisible = true;
      })
      .catch(error => {
        console.error(error);
      })
      .then(response => {
        const combinedAssets = [].concat(availableAssets).concat(assignedAssets);
        const dataSource = availableAssets.map(asset => ({
          key: asset.id,
          title: asset.plate,
          description: asset.imei
        }));
        const targetKeys = assignedAssets.map(asset => asset.id);

        this.setState({
          bindingModalVisible,
          serviceManagerId,

          combinedAssets,
          availableAssets,
          assignedAssets,

          dataSource,
          targetKeys
        });
      });
  };

  cancelAssetBinding = () => {
    this.hideAssetBindingCreateModal();
  };

  hideAssetBindingCreateModal = () => {
    this.setState({
      bindingModalVisible: false,
      serviceManagerId: undefined
    });
  };

  // asset binding
  onChange = (serviceManagerId, targetKeys, direction, moveKeys) => {
    const { translationsStore } = this.props;
    this.setState({ bindingLoading: true });
    let bindingError = undefined;
    let stateTargetKeys = this.state.targetKeys;
    const imeis = moveKeys.map(key => (this.state.combinedAssets.find(asset => asset.id === key) || {}).imei);
    if (direction === 'right') {
      //bind
      api('assignServiceManagerAssets', serviceManagerId, imeis)
        .then(response => {
          stateTargetKeys = targetKeys;
        })
        .catch(error => {
          bindingError = translationsStore.translate('serviceManagers.assetsBinding.error');
        })
        .then(response => {
          this.setState({ targetKeys: stateTargetKeys, bindingLoading: false, bindingError });
        });
    }
    if (direction === 'left') {
      //unbind
      api('unassignServiceManagerAssets', serviceManagerId, imeis)
        .then(response => {
          stateTargetKeys = targetKeys;
        })
        .catch(error => {
          bindingError = translationsStore.translate('serviceManagers.assetsBinding.error');
        })
        .then(response => {
          this.setState({ targetKeys: stateTargetKeys, bindingLoading: false, bindingError });
        });
    }
  };

  render() {
    const { translationsStore } = this.props;
    const serviceManager = this.state.serviceManagers.filter(serviceManager => serviceManager.id === this.state.serviceManagerId).shift();

    return (
      <div className="ServiceManagers">
        <SMToolbar onCreate={this.promptCreateServiceManager} />
        <SMTable loading={this.state.loading} dataSource={this.state.serviceManagers} onEdit={this.promptEditServiceManager} assetBinding={this.promptAssetBinding} />
        <SMFormModal
          className="SMFormModal"
          visible={this.state.createModalVisible}
          loading={this.state.createLoading}
          submitLabel={translationsStore.translate('serviceManagers.create.modal.labelCreate')}
          onSubmit={this.handleCreateServiceManager}
          onCancel={this.cancelCreateServiceManager}
          submitError={this.state.submitError}
        />
        <SMFormModal
          className="SMFormModal"
          visible={this.state.editModalVisible}
          loading={this.state.editLoading}
          submitLabel={translationsStore.translate('serviceManagers.edit.modal.labelEdit')}
          onSubmit={this.handleEditServiceManager}
          onCancel={this.cancelEditServiceManager}
          submitError={this.state.submitError}
          data={this.state.serviceManagerFormData}
        />
        <SMAssetBindingModal
          visible={this.state.bindingModalVisible}
          onOk={() => {}}
          onCancel={this.cancelAssetBinding}
          dataSource={this.state.dataSource}
          targetKeys={this.state.targetKeys}
          loading={this.state.bindingLoading}
          bindingError={this.state.bindingError}
          serviceManagerId={this.state.serviceManagerId}
          serviceManager={serviceManager}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

export default ServiceManagers;
